module.exports = __webpack_public_path__ + "static/media/logarBackground.5d37cf53.jpg";